import appLogo from '/appLogo.svg';

export const Logo = () => {
  return (
    <div className="w-10 p-1">
      <img src={appLogo} alt="CAP logo" />
    </div>
  );
};
